/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactComponent as CarSidesBoxTruck } from '@/assets/images/car-sides-box-truck.svg';
import { ReactComponent as CarSidesHatch } from '@/assets/images/car-sides-hatch.svg';
import { ReactComponent as CarSidesPickUp } from '@/assets/images/car-sides-pick-up.svg';
import { ReactComponent as CarSidesSedan } from '@/assets/images/car-sides-sedan.svg';
import { ReactComponent as CarSidesSuv } from '@/assets/images/car-sides-suv.svg';
import { ReactComponent as CarSidesTruck } from '@/assets/images/car-sides-truck.svg';
import { ReactComponent as MotoNaked } from '@/assets/images/moto-naked.svg';
import { ReactComponent as MotoScooter } from '@/assets/images/moto-scooter.svg';
import { VehicleType } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';

interface SvgProps {
  ref: React.RefObject<SVGSVGElement>;
  className: string;
  style?: {
    width: string;
    height: string;
  };
  onLoad?: () => false | void;
  key?: number | undefined;
}

export function handlerImageCar(svgProps: SvgProps, type?: VehicleType) {
  const imageCar = {
    [VehicleType.HATCH]: <CarSidesHatch {...svgProps} />,
    [VehicleType.BOX_TRUCK]: <CarSidesBoxTruck {...svgProps} />,
    [VehicleType.PICKUP]: <CarSidesPickUp {...svgProps} />,
    [VehicleType.SEDAN]: <CarSidesSedan {...svgProps} />,
    [VehicleType.SUV]: <CarSidesSuv {...svgProps} />,
    [VehicleType.TRUCK]: <CarSidesTruck {...svgProps} />,
    [VehicleType.MOTO_NAKED]: <MotoNaked {...svgProps} />,
    [VehicleType.MOTO_SCOOTER]: <MotoScooter {...svgProps} />,
  };

  return type ? imageCar[type] : <CarSidesSedan {...svgProps} />;
}
